<template>
    <Content :margin="margin">
        <PrimaryButton
            v-if="!link"
            type="button"
            @click="handleOpenModalTellMeWhenArrive"
        >
            Avise-me quando chegar!
        </PrimaryButton>
        <span
            v-else
            class="link-tell-me-when-arrive"
            @click="handleOpenModalTellMeWhenArrive"
        >
            Avise-me quando chegar!
        </span>
    </Content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { swall } from "../../../services/sweetAlert";
import { PrimaryButton } from "../../Styles/Extends/styled";
import { Content } from "./style";

export default {
    name: "ProductTellMeWhenYouArrive",
    props: {
        margin: {
            default: "0"
        },
        item: {
            default: null
        },
        link: {
            default: false
        }
    },
    components: {
        Content,
        PrimaryButton
    },
    methods: {
        ...mapActions("tellMeWhenArrive", [
            "setForm",
            "setResetModal",
            "getSessionEmail",
            "submitSaveSubscribeTellMeWhenArrive",
            "setProductTellMeWhenArrive"
        ]),
        async handleOpenModalTellMeWhenArrive() {
            if (this.item) {
                this.setProductTellMeWhenArrive(this.item);
            }

            const { data } = await this.getSessionEmail();
            data.product_id = this.product.id;
            data.product_link = this.product?.url_pro;

            if (data.email && data.name) {
                this.submitSaveSubscribeTellMeWhenArrive(data)
                    .then(() =>
                        swall(
                            "Assinatura realizada com sucesso!",
                            false,
                            "check",
                            "success"
                        )
                    )
                    .catch(error =>
                        swall(error?.msg ?? error?.message ?? error, true)
                    );

                return;
            }

            this.setResetModal(true);
            this.setForm(data);
            this.$root.showModalApp("modal_tell_me_when_you_arrive");
        }
    },
    computed: {
        ...mapState("tellMeWhenArrive", ["product"])
    }
};
</script>
